// removed by extract-text-webpack-plugin
module.exports = {"Submit":"_3J8A7jjuv9GJyw-YSabJLd","Block":"_1H4Z6_i9opKYM7L5z5CQ6j","Intro":"_1yrDtOfmx0EGoDSHeEdChV","Blank":"_2FqwCZPKxAbnLGla4GKBZs","Label":"_7B6SMYg5G-sqY4H2NSvcq","Pictures":"_1h-cZmW6botzzXwDw3kTws","Content":"_2slksMl15VUBTSunY3_Bwi","First":"WZWs2YsYE2B86ya49zPfl","Second":"_3NVoLIXS1_2WaFeU_hPddg","SecondWidth":"_2YdSEbwQaNX3Qijmw0Dlwd"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Contact/Contact.css
// module id = 383
// module chunks = 0